import { render, staticRenderFns } from "./yuItem.vue?vue&type=template&id=08ce167b&scoped=true&"
import script from "./yuItem.vue?vue&type=script&lang=js&"
export * from "./yuItem.vue?vue&type=script&lang=js&"
import style0 from "./yuItem.vue?vue&type=style&index=0&id=08ce167b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce167b",
  null
  
)

export default component.exports